/* eslint-disable */
import axios from 'axios';
import config from '@assets/config.json'; // api 请求json  
// 通用 Module 
const state = {
}
const mutations = {
}
const getters = {
}
const actions = {
    getWebKindGetByAgent({ rootState }, id) { // 根据展会Id获取网站产品类别
        return new Promise((resolve, reject) => {
            axios.get(`${config.api.reqApi}/api/WebKind/GetByAgent?agentId=${id}`, rootState.header).then(data => {
                if (data.data) {
                    resolve(data.data);
                } else {
                    resolve(null);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    putWebKind({ rootState }, opt) { // 修改网站产品类别（WebKind）
        return new Promise((resolve, reject) => {
            axios.put(`${config.api.reqApi}/api/WebKind`, opt, rootState.header).then(data => {
                if (data.data) {
                    resolve(data.data);
                } else {
                    resolve(null);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    putWebKindCategory({ rootState }, opt) { // 修改网站产品类别（WebKind）
        return new Promise((resolve, reject) => {
            axios.put(`${config.api.reqApi}/api/WebKind/Category`, opt, rootState.header).then(data => {
                if (data.data) {
                    resolve(data.data);
                } else {
                    resolve(null);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    delWebKind({ rootState }, id) { // 删除网站产品类别（WebKind）
        return new Promise((resolve, reject) => {
            axios.delete(`${config.api.reqApi}/api/WebKind?id=${id}`, rootState.header).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err.response.data);
            });
        });
    },

    addWebKind({ rootState }, opt) { // 增加网站产品类别
        return new Promise((resolve, reject) => {
            axios.post(`${config.api.reqApi}/api/WebKind`, opt, rootState.header).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    }, 

 
}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
} 